import { render } from "./InfoConnectTelegramBot.vue?vue&type=template&id=7a63cf96&scoped=true"
import script from "./InfoConnectTelegramBot.vue?vue&type=script&lang=js"
export * from "./InfoConnectTelegramBot.vue?vue&type=script&lang=js"

import "./InfoConnectTelegramBot.vue?vue&type=style&index=0&id=7a63cf96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a63cf96"]])

export default __exports__